import NewLayout from "@components/new-ui/Layout";
import { CompanyTrustBanner } from "@components/Webinar/CompanyTrustBanner";
import IndividualWebinar, { IndividualWebinarProps } from "@components/Webinar/IndividualWebinar";

const HeroSectionData: IndividualWebinarProps = {
    title: "Launch Your WhatsApp Chatbot in Just 5 Minutes",
    listHeading: "Ready to automate your WhatsApp like the pros?",
    listText: [
        { label: "Learn how to automate FAQs, capture leads, send offers & more" },
        { label: "Build a chatbot live using drag-and-drop tools" },
        { label: "See real chatbot examples from top-performing SMBs" },
        { label: "Get free templates + a step-by-step guide to launch yours today" },
    ],
    mediaUrl: "https://assets.gallabox.com/gb-home/webinar/webinar-7.png",
    speakerList: [
        {
            image: "/ranganayaki.png",
            name: "Ranganayaki R",
            role: "Whatsapp Evangelist",
        },
        {
            image: "/shoaib.png",
            name: "Shoaib Ahmed",
            role: "Growth Specialist",
        },
    ],
    youtubeURL: "https://youtu.be/lFYdWYgeZtQ",
    inThisWebinar: "In this hands-on masterclass, we’ll show you how to build and launch your first chatbot for WhatsApp—no coding required—in just 5 minutes!",
    webinarSlug: "building-whatsapp-chatbot",
};

const Webinar: React.FC = () => {
    return (
        <NewLayout
            title="Build & Launch Your First WhatsApp Chatbot in 5 Minutes"
            description="Learn how to create and launch a fully functional WhatsApp chatbot in minutes. No code. No hassle."
            canonical="https://gallabox.com/webinars/building-whatsapp-chatbot"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/webinar/webinar-7.png" }}
        >
            <IndividualWebinar {...HeroSectionData} />
            <CompanyTrustBanner />
        </NewLayout>
    );
};

export default Webinar;
